import { AllowChangeGrid } from '../../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import { GenericRule } from '../../../../../../../utils/genericValidator.util';
import { isPreOrder } from '../../../../../../products/utils/availability.utils';
import { OfflineOrderProduct } from '../../OfflineOrderProduct';

export class ValidateClosedGridRule implements GenericRule<OfflineOrderProduct> {
  validateOrThrow(orderProduct: OfflineOrderProduct) {
    const allowChangeToAvailability = isPreOrder(orderProduct.availability)
      ? orderProduct.productColor.allowChangePreOrderGrid
      : orderProduct.productColor.allowChangeImmediateGrid;

    const isClosedGrid = allowChangeToAvailability === AllowChangeGrid.DISALLOW;

    if (!isClosedGrid) {
      return;
    }

    const hasGridWithQuantity = orderProduct.grid.some((gridItem) => gridItem.quantity > 0);
    const hasPacks = !!orderProduct.packs?.length;

    if (hasGridWithQuantity && !hasPacks) {
      throw new Error('order product must have packs');
    }
  }
}
